import React, { useRef } from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { json, Link, useNavigate } from "react-router-dom";
import signin from "../../assets/img/signin.svg";
import {
  userLogin,
  userLoginPhone,
  userResendOtp,
  verifyOtp,
} from "../../Redux/Auth";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import { useFormik } from "formik";
import * as Yup from "yup";
import firebase from "firebase/compat/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { firebaseConfig } from "../../fireBaseConfig";
import ToasterMessage from "../ToasterMessage";
// import SmallLoder from '../Loaders/SmallLoder';
import loader from "../../assets/img/loader.gif";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import ZIM from "zego-zim-web";
import { useEffect } from "react";
import { setOneSignal } from "../functions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setUserLoginDetails } from "../../slices/user/userSlice";

const app = firebase.initializeApp(firebaseConfig);
const auth = getAuth(app);

const SignIn = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector((state) => state.user)

  const fireBaseLogin = async (email, password) => {
    await signInWithEmailAndPassword(auth, email, email)
      .then(function (user) {

      })
      .catch(function (error) {

      });
    navigate("/");
  };
  const [isloader, setIsloader] = useState(false);
  const [toaster, setToaster] = useState("");
  const [switchbutton, setSwitchbutton] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [password, setPassword] = useState(false);
  const navigate = useNavigate();

  const viewPassword = () => {
    setPassword(!password);
  };

  const validationSchema = Yup.object().shape({
    phone: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Enter a valid mobile number")
      .required("Required"),
  });
  const validationSchema1 = Yup.object().shape({
    username: Yup.string().required("Required"),
    password: Yup.string()
      .required("Password is mandatory")
      .min(8, "Password must be at 8 char long"),
  });
  const formikPhone = useFormik({
    initialValues: {
      phone: "",
      type_of_user: "1",
    },
    validationSchema,
    onSubmit: (values) => {
      __formSubmit(values);
    },
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      otp: "",
    },
    validationSchema1,
    onSubmit: (values) => {

      __formSubmit(values);
    },
  });
  const __formSubmit = async (values) => {
    setIsloader(true);
    let tab1 = document.getElementById("tab-1")?.checked;
    let tab2 = document.getElementById("tab-2")?.checked;
    let formData = new FormData(); //formdata object
    
    // Non-blocking OneSignal token retrieval
    let oneSignalPlayerID = localStorage.getItem("onesignal_token") || "";
    try {
      const token = await setOneSignal();
      if (token) oneSignalPlayerID = token;
    } catch (e) {
      console.error("OneSignal error", e);
    }

    if (tab2 && values.username && values.password) {
      let username = values.username.toLowerCase();

      formData.append("username", username);
      formData.append("password", values.password);
      formData.append("type_of_user", values.type_of_user || "1");
      formData.append("notification_token", oneSignalPlayerID ?? "");
      userLogin({ formData })((response) => {
        if (response && response.status) {

          dispatch(setUserLoginDetails({
            ...response.data.user,
            isAuth: true,
            token: response.data.token,
            refresh_token: response.data.token,
            user_type: response.data.user.type_of_user,
            notificationCount: ""
          }))
          setIsloader(false);
          localStorage.setItem("refresh_token", response.data.refresh);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user_type", response.data.user.type_of_user);
          localStorage.setItem("user_name", response.data.user.username);
          localStorage.setItem("user_id", response.data.user.id);
          localStorage.setItem("user_image", response.data.user.image.image);
          // localStorage.setItem("user)", JSON.stringify(response.data.user));

          if (response?.data?.user?.is_phone_autheticated == false) {
            navigate("/verifymobile");
            return;
          }
          if (
            response.data.user.type_of_user == 2 &&
            response.data.user.status == 2
          ) {
            navigate("/userdetails");
            return;
          }
          if (
            response?.data?.user?.non_reviewd_task &&
            response?.data?.user?.non_reviewd_task[0]?.task_details
          )
            localStorage.setItem("view_rating", true);
          // localStorage.setItem('non_reviewed_task', JSON.stringify(response.data.non_reviewed_task));
          fireBaseLogin(response.data.user.email, values.password)

          navigate("/", {
            state: {
              login: true,
              title: response?.data?.user?.non_reviewd_task[0]?.title,
              task_details:
                response?.data?.user?.non_reviewd_task[0]?.task_details,
            },
          });
        } else {
          setIsloader(false);
          setToaster("Invalid credentials");
          setTimeout(() => {
            setToaster("");
          }, 2000);
        }
      });
    } else {
      userLoginPhone(
        values.phone,
        values.type_of_user,
        oneSignalPlayerID
      )((response) => {
        if (response && response.status) {
          const userID = response.data.user.id;
          const userName = response.data.user.username;
          const appID = 1485872462;
          const serverSecret = process.env.REACT_APP_ZEGO_SERVER_SECRET;
          const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(
            appID,
            serverSecret,
            null,
            userID,
            userName
          );
          const zp = ZegoUIKitPrebuilt.create(TOKEN);
          zp.addPlugins({ ZIM });

          dispatch(setUserLoginDetails({
            ...response.data.user,
            isAuth: false,
            token: response.data.token,
            refresh_token: response.data.token,
            user_type: response.data.user.type_of_user,
            notificationCount: ""
          }))
          localStorage.setItem("refresh_token", response.data.refresh);
          localStorage.setItem("token_temp", response.data.token);
          localStorage.setItem("user_type", response.data.user.type_of_user);
          localStorage.setItem("user_name", response.data.user.username);
          localStorage.setItem("user_id", response.data.user.id);
          // localStorage.setItem('user_image', response.data.user.image.image);

          // if (response?.data?.user?.non_reviewd_task && response?.data?.user?.non_reviewd_task[0]?.id)
          //     localStorage.setItem('view_rating', true);
          // fireBaseLogin(response.data.user.email, "")
          setSwitchbutton(true);
          setIsloader(false);
        } else {

          formikPhone.setErrors({
            phone: response?.response?.data?.data?.errors?.phone,
            type_of_user: response?.response?.data?.data?.errors?.type_of_user,
          });
          setIsloader(false);
          setToaster("Invalid mobile");
          setTimeout(() => {
            setToaster("");
          }, 2000);
        }
      });
    }
  };

  const __onVerifyOtp = (e) => {
    e.preventDefault();
    localStorage.setItem("token", localStorage.getItem("token_temp"));
    localStorage.removeItem("token_temp");
    setIsloader(true);

    verifyOtp(formik.values.otp, localStorage.getItem("onesignal_token") || "")((response) => {

      if (response && response.status) {

        dispatch(setUserLoginDetails({
          ...userDetails,
          isAuth: true,
        }))
        setIsloader(false);

        if (response.data.type_of_user == 2 && response.data.status == 2) {
          navigate("/userdetails");
          return;
        }
        // setShowOtp(false)
        if (localStorage.getItem("user_type")) {
          if (
            response?.data?.non_reviewd_task &&
            response?.data?.non_reviewd_task[0]?.task_details
          )
            localStorage.setItem("view_rating", true);

          navigate("/", {
            state: {
              login: true,
              title: response?.data?.non_reviewd_task[0]?.title,
              task_details: response?.data?.non_reviewd_task[0]?.task_details,
            },
          });
        } else {
          setToaster("Error");
          setTimeout(() => {
            setToaster("");
          }, 2000);
        }
      } else {
        setIsloader(false);

        setOtpError(response.response.data.message);
        localStorage.setItem("token_temp", localStorage.getItem("token"));
        localStorage.removeItem("token");



        setTimeout(() => {
          setToaster("");
        }, 2000);
      }
    });
  };
  const resendOTP = () => {

    userResendOtp(
      formikPhone.values.phone,
      localStorage.getItem("user_type")
    )((response) => {

    });
  };



  const bottomRef = useRef(null);

  const scrollToTop = () => {
    bottomRef.current?.scrollIntoView({ block: "start" });
  };



  return (
    <React.Fragment>
      <ToasterMessage toaster={toaster} setToaster={setToaster} />
      <Header />
      <section ref={bottomRef}>
        <div className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-md-12 my-auto">
                <h1>Sign In </h1>
                <ul className="trail-items">
                  <li className="trail-item trail-begin">
                    <Link to="/">
                      <span itemProp="name">Home</span>
                      <i className="bi bi-chevron-double-right"></i>
                    </Link>
                  </li>
                  <li className="trail-item trail-end">
                    <span itemProp="item">
                      <span itemProp="name"> Sign In</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="signinpage">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img src={signin} alt="" className="img-fluid" />
            </div>
            <div className="col-lg-6">
              <div className="login-wrap">
                <div className="login-html">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="signintitle">
                        <h1>Sign In</h1>
                      </div>
                    </div>
                  </div>
                  <input
                    id="tab-1"
                    type="radio"
                    name="tab"
                    className="sign-in"
                    defaultChecked={true}
                  />
                  <label htmlFor="tab-1" className="tab">
                    Phone Number
                  </label>
                  <input
                    id="tab-2"
                    type="radio"
                    name="tab"
                    className="sign-up"
                  />
                  <label htmlFor="tab-2" className="tab">
                    Username
                  </label>
                  <div className="login-form">
                    <div className="sign-in-htm">
                      <Form onSubmit={formikPhone.handleSubmit}>
                        {!switchbutton ? (
                          <React.Fragment>
                            {/* <Form.Label>Select User <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Select name="type_of_user" className='mb-3' onChange={formikPhone.handleChange}>
                                                            <option value=''>Select User Type</option>
                                                            <option value={1}>Buyer</option>
                                                            <option value={2}>Seller</option>
                                                        </Form.Select> */}

                            <div className="switches-container mb-4">
                              <input
                                type="radio"
                                id="switchMonthly"
                                name="type_of_user"
                                onChange={formikPhone.handleChange}
                                value="1"
                                checked={
                                  formikPhone?.values?.type_of_user == 1
                                    ? true
                                    : false
                                }
                              />
                              <input
                                type="radio"
                                id="switchYearly"
                                name="type_of_user"
                                onChange={formikPhone.handleChange}
                                value="2"
                                checked={
                                  formikPhone?.values?.type_of_user == 2
                                    ? true
                                    : false
                                }
                              />
                              <label htmlFor="switchMonthly">Buyer</label>
                              <label htmlFor="switchYearly">Seller</label>
                              <div className="switch-wrapper">
                                <div className="switch">
                                  <div>Buyer</div>
                                  <div>Seller</div>
                                </div>
                              </div>
                            </div>

                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label>
                                Mobile Number{" "}
                                <span style={{ color: "#db3131" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                name="phone"
                                onChange={formikPhone.handleChange}
                                isValid={
                                  formikPhone.touched.phone &&
                                  !formikPhone.errors.phone
                                }
                                isInvalid={!!formikPhone.errors.phone}
                                placeholder="Enter Mobile Number"
                                required
                                type="number"
                                maxLength={10}
                                value={formikPhone.values.phone}
                              />
                              <Form.Control.Feedback type="invalid">
                                {formikPhone.errors.phone}
                              </Form.Control.Feedback>
                            </Form.Group>

                            <div className="group">
                              {isloader == true ? (
                                <div className="loader">
                                  <img src={loader} alt="" />
                                </div>
                              ) : (
                                <Button
                                  type="submit"
                                  className="btn btn-primary next-btn mt-3 mb-3"
                                >
                                  Submit{" "}
                                </Button>
                              )}
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label>
                                Enter OTP{" "}
                                <span style={{ color: "#db3131" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                name="otp"
                                onChange={formik.handleChange}
                                isValid={
                                  formik.touched.otp && !formik.errors.otp
                                }
                                isInvalid={!!formik.errors.otp}
                                maxLength="255"
                                placeholder="Enter OTP"
                                required
                                value={formik.values.otp}
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.otp}
                              </Form.Control.Feedback>
                            </Form.Group>

                            {otpError && (
                              <div className="d-flex justify-content-center text-danger">
                                {otpError}
                              </div>
                            )}
                            <div className="group">
                              <Button
                                type="submit"
                                className="btn btn-primary next-btn mt-3 mb-3"
                                onClick={(e) => __onVerifyOtp(e)}
                              >
                                Verify
                              </Button>
                            </div>

                            <div className="forgot-pass">
                              <span
                                onClick={() => {
                                  resendOTP();
                                }}
                              >
                                Resend OTP?{" "}
                              </span>
                            </div>
                          </React.Fragment>
                        )}

                        <div className="hr"></div>

                        <div className="foot-lnk">
                          <p>
                            Don't have an account?{" "}
                            <Link to="/signup">Sign Up</Link>
                          </p>
                        </div>
                      </Form>
                    </div>
                    <div className="sign-up-htm">
                      <Form onSubmit={formik.handleSubmit}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Username <span style={{ color: "#db3131" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            name="username"
                            onChange={formik.handleChange}
                            maxLength="40"
                            placeholder="Enter the User Name"
                            required
                            value={formik.values.username}
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.username}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          <Form.Label>
                            Password <span style={{ color: "#db3131" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            name="password"
                            type={password ? "text" : "password"}
                            onChange={formik.handleChange}
                            maxLength="12"
                            placeholder="Password"
                            required
                            value={formik.values.password}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.password}
                          </Form.Control.Feedback>
                          <div className="icon-eye">
                            {password ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                fill="currentColor"
                                onClick={() => {
                                  viewPassword();
                                }}
                                className="bi bi-eye"
                                viewBox="0 0 16 16"
                              >
                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                fill="currentColor"
                                onClick={() => {
                                  viewPassword();
                                }}
                                className="bi bi-eye-slash"
                                viewBox="0 0 16 16"
                              >
                                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                              </svg>
                            )}
                          </div>
                        </Form.Group>

                        <div className="group">
                          {isloader == true ? (
                            <div className="loader">
                              <img src={loader} alt="" className="img-fluid" />
                            </div>
                          ) : (
                            <Button
                              type="submit"
                              className="btn btn-primary next-btn mt-3 mb-3"
                            >
                              Submit{" "}
                            </Button>
                          )}
                        </div>

                        <div className="forgot-pass">
                          <Link className="" to="/forgotpassword">
                            Forgot password?{" "}
                          </Link>
                        </div>
                        <div className="hr"></div>

                        <div className="foot-lnk">
                          <p>
                            Don't have an account?{" "}
                            <Link to="/signup">Sign Up</Link>
                          </p>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer scrollToTop={scrollToTop} />
    </React.Fragment>
  );
};

export default SignIn;
